import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
    de: {
        // Navigation
        'nav.services': 'Leistungen',
        'nav.software': 'Software',
        'nav.references': 'Referenzen',
        'nav.about': 'Über uns',
        'nav.contact': 'Kontakt',
        'nav.login': 'Anmelden',
        'nav.register': 'Registrieren',
        'nav.portal': 'Kundenportal',
        'nav.admin': 'Admin',
        'nav.logout': 'Abmelden',
        
        // Hero
        'hero.title': 'Digitale Lösungen für Ihr Unternehmen',
        'hero.subtitle': 'Webentwicklung, SEO-Optimierung und maßgeschneiderte Software aus einer Hand.',
        'hero.cta': 'Projekt starten',
        'hero.learnMore': 'Mehr erfahren',
        
        // Services
        'services.title': 'Unsere Leistungen',
        'services.subtitle': 'Alles was Sie für Ihren digitalen Erfolg brauchen',
        'services.web.title': 'Webentwicklung',
        'services.web.desc': 'Moderne, responsive Websites und Web-Anwendungen nach Maß.',
        'services.seo.title': 'SEO-Analyse',
        'services.seo.desc': 'Professionelle Suchmaschinenoptimierung für bessere Rankings.',
        'services.software.title': 'Software-Entwicklung',
        'services.software.desc': 'Individuelle Software-Lösungen für Ihre Geschäftsprozesse.',
        
        // CTA
        'cta.title': 'Bereit für Ihr nächstes Projekt?',
        'cta.subtitle': 'Kontaktieren Sie uns noch heute für ein unverbindliches Beratungsgespräch.',
        'cta.button': 'Jetzt Kontakt aufnehmen',
        
        // Footer
        'footer.rights': 'Alle Rechte vorbehalten.',
        'footer.privacy': 'Datenschutz',
        'footer.imprint': 'Impressum',
        'footer.cookies': 'Cookie-Einstellungen',
        
        // Auth
        'auth.login.title': 'Anmelden',
        'auth.login.subtitle': 'Melden Sie sich in Ihrem Konto an',
        'auth.login.email': 'E-Mail-Adresse',
        'auth.login.password': 'Passwort',
        'auth.login.submit': 'Anmelden',
        'auth.login.forgot': 'Passwort vergessen?',
        'auth.login.noAccount': 'Noch kein Konto?',
        'auth.login.register': 'Jetzt registrieren',
        
        'auth.register.title': 'Registrieren',
        'auth.register.subtitle': 'Erstellen Sie Ihr Kundenkonto',
        'auth.register.firstName': 'Vorname',
        'auth.register.lastName': 'Nachname',
        'auth.register.email': 'E-Mail-Adresse',
        'auth.register.password': 'Passwort',
        'auth.register.confirmPassword': 'Passwort bestätigen',
        'auth.register.submit': 'Konto erstellen',
        'auth.register.hasAccount': 'Bereits registriert?',
        'auth.register.login': 'Jetzt anmelden',
        'auth.register.success': 'Registrierung erfolgreich! Bitte bestätigen Sie Ihre E-Mail-Adresse.',
        
        // Portal
        'portal.dashboard': 'Dashboard',
        'portal.tickets': 'Tickets',
        'portal.profile': 'Profil',
        'portal.newTicket': 'Neues Ticket',
        'portal.welcome': 'Willkommen',
        
        // Tickets
        'ticket.subject': 'Betreff',
        'ticket.category': 'Kategorie',
        'ticket.status': 'Status',
        'ticket.priority': 'Priorität',
        'ticket.created': 'Erstellt am',
        'ticket.message': 'Nachricht',
        'ticket.send': 'Senden',
        'ticket.noTickets': 'Keine Tickets vorhanden',
        'ticket.createFirst': 'Erstellen Sie Ihr erstes Ticket',
        
        // Common
        'common.loading': 'Lädt...',
        'common.error': 'Ein Fehler ist aufgetreten',
        'common.save': 'Speichern',
        'common.cancel': 'Abbrechen',
        'common.delete': 'Löschen',
        'common.edit': 'Bearbeiten',
        'common.create': 'Erstellen',
        'common.search': 'Suchen...',
        'common.all': 'Alle',
        'common.back': 'Zurück',
        'common.next': 'Weiter',
        'common.previous': 'Zurück',
    },
    en: {
        // Navigation
        'nav.services': 'Services',
        'nav.software': 'Software',
        'nav.references': 'References',
        'nav.about': 'About Us',
        'nav.contact': 'Contact',
        'nav.login': 'Login',
        'nav.register': 'Register',
        'nav.portal': 'Customer Portal',
        'nav.admin': 'Admin',
        'nav.logout': 'Logout',
        
        // Hero
        'hero.title': 'Digital Solutions for Your Business',
        'hero.subtitle': 'Web development, SEO optimization, and custom software from a single source.',
        'hero.cta': 'Start Project',
        'hero.learnMore': 'Learn More',
        
        // Services
        'services.title': 'Our Services',
        'services.subtitle': 'Everything you need for your digital success',
        'services.web.title': 'Web Development',
        'services.web.desc': 'Modern, responsive websites and web applications tailored to your needs.',
        'services.seo.title': 'SEO Analysis',
        'services.seo.desc': 'Professional search engine optimization for better rankings.',
        'services.software.title': 'Software Development',
        'services.software.desc': 'Custom software solutions for your business processes.',
        
        // CTA
        'cta.title': 'Ready for your next project?',
        'cta.subtitle': 'Contact us today for a free consultation.',
        'cta.button': 'Get in Touch',
        
        // Footer
        'footer.rights': 'All rights reserved.',
        'footer.privacy': 'Privacy Policy',
        'footer.imprint': 'Imprint',
        'footer.cookies': 'Cookie Settings',
        
        // Auth
        'auth.login.title': 'Sign In',
        'auth.login.subtitle': 'Sign in to your account',
        'auth.login.email': 'Email Address',
        'auth.login.password': 'Password',
        'auth.login.submit': 'Sign In',
        'auth.login.forgot': 'Forgot password?',
        'auth.login.noAccount': "Don't have an account?",
        'auth.login.register': 'Register now',
        
        'auth.register.title': 'Register',
        'auth.register.subtitle': 'Create your customer account',
        'auth.register.firstName': 'First Name',
        'auth.register.lastName': 'Last Name',
        'auth.register.email': 'Email Address',
        'auth.register.password': 'Password',
        'auth.register.confirmPassword': 'Confirm Password',
        'auth.register.submit': 'Create Account',
        'auth.register.hasAccount': 'Already registered?',
        'auth.register.login': 'Sign in now',
        'auth.register.success': 'Registration successful! Please verify your email address.',
        
        // Portal
        'portal.dashboard': 'Dashboard',
        'portal.tickets': 'Tickets',
        'portal.profile': 'Profile',
        'portal.newTicket': 'New Ticket',
        'portal.welcome': 'Welcome',
        
        // Tickets
        'ticket.subject': 'Subject',
        'ticket.category': 'Category',
        'ticket.status': 'Status',
        'ticket.priority': 'Priority',
        'ticket.created': 'Created',
        'ticket.message': 'Message',
        'ticket.send': 'Send',
        'ticket.noTickets': 'No tickets found',
        'ticket.createFirst': 'Create your first ticket',
        
        // Common
        'common.loading': 'Loading...',
        'common.error': 'An error occurred',
        'common.save': 'Save',
        'common.cancel': 'Cancel',
        'common.delete': 'Delete',
        'common.edit': 'Edit',
        'common.create': 'Create',
        'common.search': 'Search...',
        'common.all': 'All',
        'common.back': 'Back',
        'common.next': 'Next',
        'common.previous': 'Previous',
    },
};

export function LanguageProvider({ children }) {
    const language = 'de'; // Fixed to German only

    useEffect(() => {
        document.documentElement.lang = 'de';
    }, []);

    const t = (key) => {
        return translations['de']?.[key] || key;
    };

    const value = {
        language: 'de',
        setLanguage: () => {},
        toggleLanguage: () => {},
        t,
        isGerman: true,
        isEnglish: false,
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}

export default LanguageContext;
